import React, { useState } from "react";
import { Eye } from "lucide-react";

const getFileType = (filename) => {
  if(filename){
    const ext = filename.split(".").pop().toLowerCase();
  if (ext === "pdf") return { type: "pdf", label: "PDF", bg: "bg-red-100", text: "text-red-600" };
  if (["jpg", "jpeg", "png", "webp", "gif", "bmp"].includes(ext))
    return { type: "image", label: "IMG", bg: "bg-blue-100", text: "text-blue-600" };
  }
  return { type: "other", label: "FILE", bg: "bg-gray-200", text: "text-gray-600" };
};

const ReportViewer = ({ files = [] }) => {
  const [previewFile, setPreviewFile] = useState(null);

  const openPreview = (file) => setPreviewFile(file);
  const closePreview = () => setPreviewFile(null);

  return (
    <div className="max-w-md mx-auto space-y-4">
      {files.map((file, index) => {
        const fileInfo = getFileType(file.filePath);
        return (
          <div
            key={index}
            className="bg-gray-50 rounded-xl p-4 flex justify-between items-center shadow-sm"
          >
            <div className="flex items-center gap-3">
              <span
                className={`text-xs font-semibold px-2 py-1 rounded-md ${fileInfo.bg} ${fileInfo.text}`}
              >
                {fileInfo.label}
              </span>
              <div className="flex flex-col">
                <span className="text-sm text-gray-800 font-medium">{file.reportName}</span>
                <span className="text-xs text-gray-500">1.2MB</span>
              </div>
            </div>
            <button
              onClick={() => openPreview(file)}
              className="text-blue-600 hover:text-blue-800"
            >
              <Eye size={16} />
            </button>
          </div>
        );
      })}

      {/* Modal Viewer */}
      {previewFile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-4xl mx-4 rounded-xl shadow-lg relative">
            <button
              onClick={closePreview}
              className="absolute top-4 right-4 text-gray-500 hover:text-red-600 text-2xl"
            >
              &times;
            </button>

            <div className="p-6">
              <h2 className="text-lg font-semibold mb-4 text-gray-800">{previewFile.reportName}</h2>
              <div className="border rounded overflow-hidden max-h-[75vh]">
                {getFileType(previewFile.filePath).type === "image" ? (
                  <img
                    src={previewFile.filePath}
                    alt={previewFile.reportName}
                    className="w-full object-contain max-h-[70vh] mx-auto"
                  />
                ) : getFileType(previewFile.filePath).type === "pdf" ? (
                  <iframe
                    src={previewFile.filePath}
                    title={previewFile.reportName}
                    className="w-full h-[70vh]"
                  />
                ) : (
                  <p className="text-gray-500 p-4 text-center">Preview not supported</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportViewer;
